<script lang="ts" setup>
import { reactive } from 'vue'
import { StepinHeaderAction } from 'stepin'
import Notice from '@/components/notice/Notice.vue'
import DayNightSwitch from '@/components/switch/DayNightSwitch.vue'
import { BellOutlined } from '@ant-design/icons-vue'
import Fullscreen from '../fullscreen/Fullscreen.vue'
import { useRouter } from 'vue-router'
import { useAccountStore } from '@/store'
import { message } from 'ant-design-vue'
const router = useRouter()
const accountStore = useAccountStore()
const { userInfo } = accountStore

defineEmits<{
  (e: 'showSetting'): void
}>()

const handleDataScreen = () => {
  let isAdmin = userInfo.adminRoleList.findIndex(
    (item) =>
      item.keyName === 'admin' ||
      item.keyName === 'boss' ||
      item.keyName === 'manager' ||
      item.keyName === 'assistant-manager'
  )
  if (isAdmin === -1) {
    message.error('您没有权限访问数据大屏')
    return
  }
  // 跳转新标签页使用vue路由
  // 使用 window.open 打开一个新标签页，并导航到关于页面
  const newTab = window.open('', '_blank')

  // 生成哈希路由的 URL
  const url = router.resolve({ name: 'datascreen' }).href

  // 设置新标签页的 location.href 为生成的 URL
  newTab.location.href = url
}
</script>
<template>
  <StepinHeaderAction>
    <!-- <a-input placeholder="开始搜索...">
      <template #prefix>
        <search-outlined />
      </template>
    </a-input> -->
  </StepinHeaderAction>
  <StepinHeaderAction>
    <DayNightSwitch />
  </StepinHeaderAction>
  <!-- <StepinHeaderAction>
    <a class="action-item" href="http://github.com/stepui/stepin-template" target="_blank">
      <GithubOutlined />
    </a>
  </StepinHeaderAction>
  <StepinHeaderAction>
    <a class="action-item" href="http://gitee.com/stepui/stepin-template" target="_blank">
      <img class="gitee-logo" src="@/assets/gitee.svg" />
    </a>
  </StepinHeaderAction> -->
  <!-- 大屏 -->
  <!-- <StepinHeaderAction>
    <div class="action-item setting" @click="handleDataScreen" target="_blank">
      <fund-projection-screen-outlined />
    </div>
  </StepinHeaderAction> -->
  <StepinHeaderAction>
    <div class="action-item setting" @click="$emit('showSetting')">
      <SettingOutlined />
    </div>
  </StepinHeaderAction>

  <a-popover placement="bottomRight">
    <StepinHeaderAction>
      <div class="action-item notice">
        <BellOutlined />
      </div>
    </StepinHeaderAction>
    <!-- <template #content>
      <Notice :data-source="noticeList" />
    </template> -->
  </a-popover>
  <StepinHeaderAction>
    <Fullscreen class="-mx-xs -my-sm h-[56px] px-xs py-sm flex items-center" target=".stepin-layout" />
  </StepinHeaderAction>
</template>
<style scoped lang="less">
.gitee-logo {
  width: 20px;
}
.action-item {
  font-size: 20px;
  height: 100%;
  margin: 0 -8px;
  padding: 0 4px;
  line-height: 40px;
  display: flex;
  align-items: center;

  &.setting {
    font-size: 18px;
  }

  &.notice {
    font-size: 18px;
  }
}
</style>
